// Convert a Lithuanian first/last name (or full name) to vocative case
// for greetings like "Sveiki, Artūrai," instead of "Sveiki, Artūras,".
//
// Rules cover the common name endings. Order matters: longer / more
// specific suffixes are checked first so "Marius" → "Mariau" (via -ius)
// is not pre-empted by the -us rule. Female names ending in -a are
// left unchanged (their vocative is the same form in Lithuanian), as
// are anything that doesn't match a known suffix.
const VOCATIVE_RULES: Array<[RegExp, string]> = [
  [/ius$/, "iau"],
  [/ys$/, "y"],
  [/us$/, "au"],
  [/as$/, "ai"],
  [/is$/, "i"],
  [/ė$/, "e"],
  [/IUS$/, "IAU"],
  [/YS$/, "Y"],
  [/US$/, "AU"],
  [/AS$/, "AI"],
  [/IS$/, "I"],
  [/Ė$/, "E"],
];

function wordToVocative(word: string): string {
  if (word.length < 2) return word;
  for (const [pattern, replacement] of VOCATIVE_RULES) {
    if (pattern.test(word)) {
      return word.replace(pattern, replacement);
    }
  }
  return word;
}

export function toLithuanianVocative(name: string | null | undefined): string {
  if (!name) return "";
  return name
    .split(/(\s+)/)
    .map((part) => (/^\s+$/.test(part) || part === "" ? part : wordToVocative(part)))
    .join("");
}
